/* import __COLOCATED_TEMPLATE__ from './form-feedback-bubble.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { TYPES } from 'sh-www/constants/form-feedback-bubble';

/** A wrapper component which handles the visibility and type of the form-feedback-bubble. */
export default Component.extend({
  tagName: '',

  /** @param {String} type The type of feedback. */
  type: TYPES.NONE,

  /** @type {Boolean} Whether this component should be shown. */
  _isVisible: computed('type', function () {
    return [TYPES.ERROR, TYPES.WARNING].includes(this.type);
  }),
});
